export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const { forceCloseAllTheDialog } = useDialog()
  router.beforeEach((to, from, next) => {
    forceCloseAllTheDialog()
    next()
  })
})
